export const createUrlParametersString = (param: any) => Object.keys(param).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(param[key])).join('&');
export const createUrlMultiParameterString = (key: string, param: any[]) => param.map((s: any) => encodeURIComponent(key) + '=' + encodeURIComponent(s)).join('&');

export const createFilterObj = (field: string, operator: string, value: any) => ({
  field: field,
  operator: operator,
  value: value
})

export const trimInputFields = (input: string) => input.replace(/"\s+|\s+"/g,'"');